<template>
  <div class="kabaddi-season">
    <loading-state :state="state"></loading-state>
    <div v-if="stats">
      <h2>Stats</h2>
      <kabaddi-season-menu :seasonKey="seasonKey"></kabaddi-season-menu>

      <section>
        <h3>Player Stats</h3>
        <div class="sub-content">
          <div class="item compact">
            <div>
              <span class="tag size-1-3 tableview" v-for="(data, name) in stats.player" :key="name">
                <h4 class="table-heading">{{name | capitalise}}</h4>
                <table>
                  <tbody>
                    <tr v-for="item in data" :key="item.$index">
                      <td>
                        <router-link
                          class="clean"
                          :to="{name:'kabaddiSeasonPlayer', params:{key:seasonKey, playerkey:item.player.key}}">
                          {{item.player.name}}</router-link>
                      </td>
                      <td>{{Object.values(item.stats)[0]}}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h3>Team Stats</h3>
        <div class="sub-content">
          <div class="item compact">
            <div>
              <span class="tag size-1-3 tableview" v-for="(data, name) in stats.team" :key="name">
                <h4 class="table-heading">{{name | capitalise}}</h4>
                <table>
                  <tbody>
                    <tr v-for="item in data" :key="item.$index">
                      <td>
                        <router-link
                          class="clean"
                          :to="{name:'kabaddiSeasonTeam', params:{key:seasonKey, teamkey:seasonKey + '_' + item.team.key}}">
                          {{item.team.name}}</router-link>
                      </td>
                      <td>{{Object.values(item.stats)[0]}}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>
<script>
import { KabaddiSeason } from '@/models/kabaddi/season'
import { DataState, AppState } from '@/state'

export default {
  data () {
    return {
      seasonKey: this.$route.params.key,
      stats: null,
      state: DataState.newLoading()
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      this.seasonKey = this.$route.params.key
      const newTitle = 'loading...'
      AppState.updateActivePage(`kabadd_season_${this.seasonKey}_stats`)
      AppState.updateTitles(newTitle, newTitle)

      KabaddiSeason.fetchStats(this.seasonKey).then(stats => {
        const newTitle = `${stats.name} Stats`
        AppState.updateTitles(newTitle, newTitle)
        this.stats = stats
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    prepareToReopen () {
      this.stats = null
    },
    refreshView () {

    }
  }
}
</script>
